.filter-bar-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.edit-columns-and-drawer,
.filter-bar-actions-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 32px;
  padding: 5px 0;
}

.edit-columns-and-drawer {
  justify-content: space-between;
  margin-left: auto;
}

@media (max-width: 970px) {
  .filter-bar-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .filter-bar-actions-wrapper {
    padding: 10px 0 5px 60px;
  }
}

.sidebar-toggle {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
}
